// extracted by mini-css-extract-plugin
module.exports = {"link":"styles-module__link___28BzD","container":"styles-module__container___1p0ey","text":"styles-module__text___1LyTf","outline":"styles-module__outline___1IENS"};